import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FileInfo, FileUploadStatus } from '@vendasta/galaxy/uploader';
import { MatDialog } from '@angular/material/dialog';
import { AttachmentsDialogComponent } from './attachments-dialog.component';
import { filter } from 'rxjs/operators';
import { SalesOrdersService } from '@vendasta/sales-orders';
import { Subscription } from 'rxjs';

@Component({
  selector: 'orders-attachments',
  templateUrl: 'attachments.component.html',
  styleUrls: ['./attachments.component.scss'],
})
export class AttachmentsComponent implements OnInit, OnDestroy {
  @Input() files: FileInfo[];
  @Input() uploadUrl: string;
  @Input() businessId: string;
  @Input() orderId: string;
  @Input() createMode = false;
  @Input() editingDisabled: boolean;

  subscriptions: Subscription[] = [];

  constructor(public dialog: MatDialog, private salesOrderService: SalesOrdersService) {
    if (!this.files) {
      this.files = [];
    }
  }

  ngOnInit(): void {
    // add upload status to previously uploaded files
    // TODO: find out how do we include this status from the parent component.
    if (this.files) {
      this.files.map((file) => {
        return (file.status = FileUploadStatus.Success);
      });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  updateAttachments(): void {
    if (this.createMode) {
      // skip if component is used in create order
      return;
    }
    const attachments = this.files.map((file) => {
      return {
        name: file.name,
        url: file.url,
      };
    });
    this.subscriptions.push(
      this.salesOrderService.updateAttachments(this.orderId, this.businessId, attachments).subscribe(),
    );
  }

  onClickAdd(): void {
    this.subscriptions.push(
      this.dialog
        .open(AttachmentsDialogComponent, {
          width: '720px',
          data: {
            uploadUrl: this.uploadUrl,
          },
        })
        .afterClosed()
        .pipe(filter(Boolean))
        .subscribe((files) => {
          if (!this.files) {
            this.files = [];
          }
          this.files = this.files.concat(files);
          this.updateAttachments();
        }),
    );
  }

  getFiles(): FileInfo[] {
    return this.files;
  }

  onFileDeleted(file: FileInfo): void {
    const index = this.files.findIndex((f) => f.name === file.name);
    this.files.splice(index, 1);
    this.updateAttachments();
  }
}
